export default[
  {
      path: '/dataList/smsTemplate',
      component: resolve => require(['../page.vue'], resolve),
      meta: {
          title: '客情维护',
          keepAlive: false
      }
  }
]